import React from 'react';
import { Rating } from '@mui/material';

import './../styles/product-info.css'

function ProductInfo() {
  const product = window.conspire_product;

  return (
    <>
      <section className="product-info-container">
        <h1 className="product-info-title">{product.title}</h1>
        {window?.conspire_product_rating && (
          <div className="product-rating-container">
            <Rating name="product-rating" value={Number(window?.conspire_product_rating?.value)} readOnly sx={{ color: '#285D3C' }} />
            <p className="product-rating-count">
              {window?.conspire_product_rating_count} Review{window?.conspire_product_rating_count > 1 ? 's' : ''}
            </p>
          </div>
        )}
      </section>
      {window.conspire_product_short_description && (
        <section className="product-short-description-container">
          <p className="product-short-description">
            {window.conspire_product_short_description}
          </p>
        </section>
      )}
    </>
  )
}

export default ProductInfo
